export function getInitials(nameOrEmail: string, fallbackToEmail = false): string {
  const parts = nameOrEmail.split(' ').filter(Boolean);

  if (parts.length > 1 || !fallbackToEmail) {
    return parts
      .slice(0, 2)
      .map((part) => part[0].toUpperCase())
      .join('');
  }

  return nameOrEmail.slice(0, 2).toUpperCase();
}
